// extracted by mini-css-extract-plugin
export default {"header":"modal_header__dZG35","main_section":"modal_main_section__TCpWV","model_button":"modal_model_button__wGl2x"};